<script>
	// Stores
	import MarketStore from '@/Stores/Sport/MarketStore.js';
	// Components
	import Switch from '@/Components/Switch.svelte';
	// Services
	import { notify } from '@/Services/Notify.js';

	export let market;

	let bonusDisabledChecked = market && !market.bonus_disabled;

	function updateBonusDisabled() {
		MarketStore.updateMarketBonusDisabled(market.id, !bonusDisabledChecked)
			.then(() => {
				notify({
					type: 'success',
					title: `${market.name}`,
					message: `Bonus Bets for Market updated to ${bonusDisabledChecked ? 'On' : 'Off'}`,
					timeout: 3
				});
			})
			.catch(() => {
				bonusDisabledChecked = !bonusDisabledChecked;
				notify({
					type: 'danger',
					title: `${market.name}`,
					message: 'Failed to update Bonus Bets',
					timeout: 3
				});
			});
	}
</script>

<div class="flex items-center justify-between">
	<div class="text-xs font-semibold uppercase whitespace-nowrap">Bonus Bets</div>
	<Switch
		on:change={updateBonusDisabled}
		name={`bonus-market-${market.id}`}
		bind:checked={bonusDisabledChecked}
		small={true}
		className=""
	/>
</div>
